import { ISvg } from '@/types/ISvg';

export default function OverflowMenu(props: ISvg) {
  const {width = 20, height = 20, color = 'currentColor', className} = props;

  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_435_177)">
        <path
          d="M25.3333 4H6.66667C5.19391 4 4 5.19391 4 6.66667V14.6667C4 16.1394 5.19391 17.3333 6.66667 17.3333H25.3333C26.8061 17.3333 28 16.1394 28 14.6667V6.66667C28 5.19391 26.8061 4 25.3333 4Z"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.6665 22.6667H27.3332"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.6665 28H27.3332"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M22 9.66667L20 11.6667L18 9.66667"
          stroke={color}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_435_177">
          <rect width="32" height="32" rx="6" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
